export default __webpack_public_path__ + "static/Image_Language-2addd00632abdda5d0b3167558b49a24.jpg";